import React, { Component } from 'react';
import { orderBy, get, find } from 'lodash';
import {
  arrayOf,
  shape,
  string,
  number,
  func,
  bool,
  objectOf
} from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';
import BaseDataTable from '../../../BaseDataTable';
import TableHead from './DeviceTableHead';
import TableRow from './DeviceTableRow';
import TableSummary from './DeviceTableSummary';
import ModuleExport from '../../../ModuleExport';
import styles from './styles.scss';
import {
  DEVICE_CATEGORY_CHART_ID,
  MIN_LENGTH_TRAFFIC_CHANNEL_DATA,
  SORT_BY_AD_VISIT,
  SORT_BY_VISIT_PER_AD,
} from '../../../../helpers/constant';
import { ADSICON_TOOLTIP_TEXT } from '../../constants';
import { calculateTableRows } from '../../Report/helper';
import { INIT_AD_VISITS_SORT } from '../constants';
class DeviceTable extends Component {
  static propTypes = {
    data: arrayOf(
      shape({
        deviceId: string,
        deviceType: string,
        totalVisits: number,
        adVisits: number,
        adUsers: number,
        ads: number
      })
    ).isRequired,
    totalAds: number,
    onCellClick: func,
    fileName: string,
    inpdf: bool,
    page: number,
    rowsPerPage: number,
    isGrandTotalDisplay: bool,
    isCustomReport: bool,
    isDisplayChart: bool,
    itemIndex: number,
    tableSortSelector: shape({
      sortKey: string,
      sortType: string
    }),
    tableColumns: objectOf(
      shape({
        title: string,
        key: string
      })
    ),
    csvColumns: objectOf(
      shape({
        title: string,
        key: string
      })
    ),
  };

  static defaultProps = {
    tableColumns: {},
    fileName: 'device_category_analytics_table'
  };

  prepData() {
    const {
      data,
      totalAds,
      inpdf,
      page,
      rowsPerPage,
      isCustomReport,
      isDisplayChart,
      tableSortSelector,
    } = this.props;
    const dataSet = data.reduce(
        (accum, currEntry) => {
          const {
            deviceId,
            deviceType,
            adVisits = 0,
            ads = 0,
            adUsers = 0,
            totalVisits,
          } = currEntry;
          if (deviceId && deviceType) {
            const visitOfAds =
              (ads && parseFloat((adVisits / ads).toFixed(2))) || 0;
            accum.tableData.push({
              deviceId,
              deviceType,
              adVisits,
              adUsers,
              ads,
              totalVisits,
              visitOfAds,
            });
          }
          accum.summaryData.adVisits += adVisits;
          accum.summaryData.adUsers += adUsers;
          accum.summaryData.ads += ads;
          accum.summaryData.totalVisits += totalVisits;
          return accum;
        },
        {
          tableData: [],
          summaryData: {
            adVisits: 0,
            adUsers: 0,
            totalVisits: 0,
            ads: 0,
            uniqueAds: totalAds
          }
        }
      );
    dataSet.summaryData.visitOfAds =
      (dataSet.summaryData.ads &&
        parseFloat(
          (dataSet.summaryData.adVisits / dataSet.summaryData.ads).toFixed(2)
        )) ||
      0;

    //TODO: update this when new report is ready
    if (inpdf) {
      const defaultSortStatus = SORT_BY_VISIT_PER_AD;
      const initialSortStatus = tableSortSelector || defaultSortStatus;
      const { sortKey, sortType } = initialSortStatus || {};
      dataSet.tableData = orderBy(dataSet.tableData, [sortKey], sortType);
      const { tableRowsFirstPage, tableRowsOtherPage } = calculateTableRows({
        displayChart: isDisplayChart,
        isCustomReport,
        minRows: MIN_LENGTH_TRAFFIC_CHANNEL_DATA
      });
      if (page === 0) {
        dataSet.tableData = dataSet.tableData.slice(0, rowsPerPage);
      } else {
        const startIndex = tableRowsFirstPage + 1 + (page - 1) * (tableRowsOtherPage + 1);
        dataSet.tableData = dataSet.tableData.slice(
          startIndex,
          startIndex + rowsPerPage
        );
      }
    }
    return dataSet;
  }

  handleCellClick = ({ data }) => {
    const { onCellClick } = this.props;
    onCellClick && onCellClick(data);
  };

  prepCsvData(data, summaryData) {
    const { csvColumns } = this.props;
    const headers = Object.values(csvColumns).map(item => item.title);
    const totalAdVisits = get(summaryData, 'adVisits');
    const csvData = data.reduce(
      (acc, current) => {
        const {
          deviceType,
          adVisits,
          ads,
          visitOfAds,
          totalVisits
        } = current;
        const adVisitsRate =
          (totalAdVisits &&
            parseFloat((adVisits / totalAdVisits).toFixed(4))) ||
          0;
        const formattedData = {
          deviceType,
          adVisits,
          ads,
          visitOfAds,
          adVisitsRate,
          totalVisits
        };
        const row = Object.keys(csvColumns).map(item => formattedData[item]);
        acc.push(row);
        return acc;
      },
      [headers]
    );
    return csvData;
  }
  /* Find the init sort base on displayed columns*/
  get initialSortStatus() {
    const {
      tableSortSelector,
      tableColumns,    
    } = this.props;
    const initSortPriority = [
      SORT_BY_AD_VISIT,
      INIT_AD_VISITS_SORT
    ];
    if (tableSortSelector) {
      initSortPriority.unshift(tableSortSelector);
    }
    return (
      find(initSortPriority, sortObj => {
        const sortKey = get(sortObj, 'sortKey');
        return tableColumns[sortKey];
      }) || {}
    );
  }

  tableExportContainer = React.createRef();
  render() {
    const {
      page,
      rowsPerPage,
      isCustomReport,
      inpdf = false,
      fileName,
      isGrandTotalDisplay,
      itemIndex,
      tableColumns
    } = this.props;
    const dataSet = this.prepData();
    const headers = Object.values(tableColumns).map(item => {
      const { key } = item;
      if (key === 'ads') {
        return {
          ...item,
          icon: (
            <Tooltip title={ADSICON_TOOLTIP_TEXT}>
              <InfoIcon className={styles.adsIcon} />
            </Tooltip>
          )
        };
      } else {
        return item;
      }
    });

    return (
      <div>
        {!inpdf && (
          <ModuleExport
            exportImg={this.tableExportContainer}
            data={this.prepCsvData(
              dataSet.tableData,
              dataSet.summaryData,
              tableColumns
            )}
            fileName={fileName}
          />
        )}
        <div
          data-test="deviceCategoryTable"
          className={styles.tableContainer}
          ref={this.tableExportContainer}
        >
          <BaseDataTable
            data={dataSet.tableData}
            tableHead={
              <TableHead
                headers={headers}
              />
            }
            tableRow={
              <TableRow
                summaryData={dataSet.summaryData}
                isCustomReport={isCustomReport}
                tableColumns={tableColumns}
              />
            }
            tableSummary={
              <TableSummary
                summaryData={dataSet.summaryData}
                tableColumns={tableColumns}
              />
            }
            onBodyCellClick={this.handleCellClick}
            initialSortStatus={this.initialSortStatus}
            pagination
            //TODO: revisit those when new report is ready
            inpdf={inpdf}
            page={page}
            rowsPerPage={rowsPerPage}
            isGrandTotalDisplay={isGrandTotalDisplay}
            tableIndex={itemIndex}
            tableId={DEVICE_CATEGORY_CHART_ID}
            isCustomReport={isCustomReport}
          />
        </div>
      </div>
    );
  }
}

import { connect } from 'react-redux';
import { getTableSortSelector } from '../../Report/helper';

function mapStateToProps(state, props) {
  return {
    tableSortSelector: getTableSortSelector(
      state,
      props,
      DEVICE_CATEGORY_CHART_ID
    )
  };
}

export default connect(mapStateToProps)(DeviceTable);
